import SettingsProvider, { SettingsProviderContext } from './SettingsProvider';
import withSettings from './withSettings';
export { SettingsProviderContext, withSettings };
export default SettingsProvider;
